import { render } from "./SavedPosts.vue.js?vue&type=template&id=08cdeaa8!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SavedPosts.vue?vue&type=template&id=08cdeaa8"
import script from "./SavedPosts.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SavedPosts.vue?vue&type=script&lang=js"
export * from "./SavedPosts.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SavedPosts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/SavedPosts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "08cdeaa8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08cdeaa8', __exports__)) {
    api.reload('08cdeaa8', __exports__)
  }
  
  module.hot.accept("./SavedPosts.vue.js?vue&type=template&id=08cdeaa8!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SavedPosts.vue?vue&type=template&id=08cdeaa8", () => {
    api.rerender('08cdeaa8', render)
  })

}


export default __exports__